module.exports = new __parcel__URL__("digitalmetering_wide.95eebc7f.png").toString();